import { Controller } from "@hotwired/stimulus"
import { useIntersection } from 'stimulus-use'
import { Alert } from "bootstrap"

export default class extends Controller {
  connect() {
    useIntersection(this)
  }

  appear(entry, observer) {
    var alertNode = document.querySelector(".alert")
    if (alertNode) {
      var alert = Alert.getOrCreateInstance(alertNode)
      setTimeout(
        () => alert.close(),
        5000
      )
    }
  }
}
